exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.collection .vux-tab-item {\n  font-size: 0.3733rem !important;\n}\n.collection .vux-tab-ink-bar {\n  height: 2px !important;\n}\n", ""]);

// exports
